import fromAnyToBool from 'utils/converters/fromAnyToBool.util';

const fromNcobEgiftSettingsToDto = (item) =>
  !item
    ? item
    : {
        can_take_voucher_payments: fromAnyToBool(item.canTakeVoucherPayments),
      };

export default fromNcobEgiftSettingsToDto;
